import { deviceType, batteryLevel, voltageLevel } from "../constant";

export const batteryCritical = (car, siteSettingsData) => {
  if (!car.UseVoltage) {
    return siteSettingsData?.GuardianCapable && !car.IsCharging && (car.BatteryLevel <= batteryLevel.critical);
  }

  else if (car.UseVoltage && car?.DevType === deviceType.FT2) {
    return car?.BatteryVoltage <= voltageLevel.critical;
  }
};